import { LOGOUT, SET_FILTERS_DATA } from "../constans/reducerActions";
import { getTableOptions } from "../utils/api/tableApi";
import { uploadSlideshowFiles } from "../utils/api/uploadApi";

export const SLIDESHOW_INITIAL_FORM = {
  kampania: "",
  klient: "",
  branza: "",
  format: "",
  copySize: "",
  files: [],
};

export const SLIDESHOW_ACCEPTED_FILES = {
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/avif": [".avif"],
  "image/gif": [".gif"],
  "image/webp": [".webp"],
  "video/webm": [".webm"],
  "video/mp4": [".mp4"],
};

const UPLOAD_FAIL_MESSAGE = "Blad podczas wysylania danych: ";

const getNextBlockId = (blocks) =>
  blocks.reduce((maxId, block) => Math.max(maxId, block.reactId), -1) + 1;

export const createEmptySlideshowBlock = (reactId) => ({
  reactId,
  ...SLIDESHOW_INITIAL_FORM,
});

export const INITIAL_SLIDESHOW_BLOCKS = [createEmptySlideshowBlock(0)];

export const mapSelectedFiles = (fileList = []) =>
  Array.from(fileList).map((file) =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
    })
  );

export const updateSlideshowBlockField = (blocks, blockIndex, field, value) =>
  blocks.map((block, index) =>
    index === blockIndex ? { ...block, [field]: value } : block
  );

export const updateSlideshowBlockFiles = (blocks, blockIndex, fileList) =>
  blocks.map((block, index) =>
    index === blockIndex
      ? {
          ...block,
          files: [...block.files, ...mapSelectedFiles(fileList)],
        }
      : block
  );

export const removeSlideshowBlockFile = (blocks, blockIndex, fileIndex) =>
  blocks.map((block, index) => {
    if (index !== blockIndex) return block;

    const fileToRemove = block.files[fileIndex];
    if (fileToRemove?.preview) {
      URL.revokeObjectURL(fileToRemove.preview);
    }

    return {
      ...block,
      files: block.files.filter((_, currentFileIndex) => currentFileIndex !== fileIndex),
    };
  });

export const removeSlideshowBlock = (blocks, reactId) =>
  blocks.filter((block) => block.reactId !== reactId);

export const addSlideshowBlock = (blocks) => [
  ...blocks,
  createEmptySlideshowBlock(getNextBlockId(blocks)),
];

export const duplicateSlideshowBlockData = (blocks, reactId) => {
  const blockToDuplicate = blocks.find((block) => block.reactId === reactId);
  if (!blockToDuplicate) return blocks;

  const duplicatedBlock = {
    ...createEmptySlideshowBlock(getNextBlockId(blocks)),
    kampania: blockToDuplicate.kampania,
    klient: blockToDuplicate.klient,
    branza: blockToDuplicate.branza,
    format: blockToDuplicate.format,
    copySize: blockToDuplicate.copySize,
    files: [],
  };

  return [...blocks, duplicatedBlock];
};

export const buildSlideshowUploadPayload = (block) => {
  const payload = new FormData();
  payload.append("kampania", block.kampania);
  payload.append("klient", block.klient);
  payload.append("branza", block.branza);
  payload.append("format", block.format);
  // NOTE: copySize is intentionally not sent to backend. It is only a client-side
  // helper label used by "Kopiuj wszystkie" formatting in the results modal.

  block.files.forEach((file) => {
    payload.append("files", file);
  });

  return payload;
};

const validateBlock = (block, blockNumber) => {
  if (!block.kampania) return `Blok ${blockNumber}: uzupelnij kampanie.`;
  if (!block.klient) return `Blok ${blockNumber}: uzupelnij klienta.`;
  if (!block.format) return `Blok ${blockNumber}: uzupelnij format.`;
  if (!block.branza) return `Blok ${blockNumber}: uzupelnij branze.`;
  if (!block.files.length) return `Blok ${blockNumber}: dodaj przynajmniej jeden plik.`;
  return "";
};

export const validateSlideshowBlocks = (blocks) => {
  for (let i = 0; i < blocks.length; i += 1) {
    const error = validateBlock(blocks[i], i + 1);
    if (error) return error;
  }

  return "";
};

export const loadSlideshowFilters = async ({ choosenTable, dispatch }) => {
  try {
    const response = await getTableOptions(choosenTable);
    dispatch({ type: SET_FILTERS_DATA, item: response.data });
  } catch (error) {
    console.error(error);
    dispatch({ type: LOGOUT });
  }
};

export const submitSlideshowBlocks = async ({
  blocks,
  setLoading,
  setResults,
  setBlocks,
}) => {
  const validationError = validateSlideshowBlocks(blocks);
  if (validationError) {
    alert(validationError);
    return false;
  }

  setLoading(true);

  const uploadResults = [];

  try {
    // TODO: Replace this loop with a single batch request after backend exposes
    // a bulk slideshow endpoint (e.g. POST /api/slideshow/upload/batch).
    for (let i = 0; i < blocks.length; i += 1) {
      const block = blocks[i];
      const payload = buildSlideshowUploadPayload(block);
      const response = await uploadSlideshowFiles(payload);

      if (!response.ok) {
        throw new Error(`Upload failed for block ${i + 1}`);
      }

      uploadResults.push({
        id: block.reactId,
        kampania: block.kampania,
        format: block.format,
        copySize: block.copySize || "",
        link: response?.data?.remoteFolderPath || "",
        message: response?.data?.message || "",
      });
    }

    setResults(uploadResults);
    setBlocks(INITIAL_SLIDESHOW_BLOCKS);
    return true;
  } catch (error) {
    alert(UPLOAD_FAIL_MESSAGE + error.message);
    return false;
  } finally {
    setLoading(false);
  }
};
